import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ActivityListModel, ActivityListResponse } from "../models/activity-list.model";
import { Result } from "../models/result.model";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ActivityListService {
    apiUrl = environment.urlApiKras + 'activity-list';

    constructor(private http: HttpClient) {}

    getActivity(id: number) {
        return this.http.get<Result<ActivityListModel>>(`${this.apiUrl}/${id}`);
    }

    createActivity(activity: ActivityListModel){
        return this.http.post<ActivityListModel>(`${this.apiUrl}/`, activity);
    }

    getAllActivity() {
        return this.http.get<ActivityListResponse>(`${this.apiUrl}/all`)
            .pipe(
                map(response => response.data.result)
            );
    }
}